import config from "../../config";

export default function ls(k: string) {
  const env = config.env == "production" ? "" : `-${config.env}`;
  return `${config.appTitle}${env}-${k}`;
}
